import React from 'react'
import { useParams } from "react-router-dom"
import SuccessStoryPost from './SuccessStoryPost';

function SuccessStory() {

    const { storyId } = useParams();
const example = 'https://www.syria.tv/sites/default/files/styles/detailed_thumb_/public/2023-09/%D8%A7%D8%B9%D8%B5%D8%A7%D8%B1-%D8%AF%D8%A7%D9%86%D9%8A%D8%A7%D9%84-%D9%84%D9%8A%D8%A8%D9%8A%D8%A7.jpg'
    return (
        <>
            {storyId ? (
                <SuccessStoryPost />
            ) :
                (

                    <div className="flex flex-col px-5 mt-20">
                        <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                            قصص النجاح
                        </div >
                        <div className="flex flex-col overflow-hidden  justify-center mt-12 w-full text-right rounded-3xl border-solid border-[3px] border-white border-opacity-30 text-zinc-100 max-md:mt-10 max-md:max-w-full">
                            <div className="flex overflow-hidden relative flex-col pt-12 min-h-[596px] max-md:max-w-full">
                                <img
                                    loading="lazy"
                                    srcSet={example}
                                    className="object-cover absolute inset-0 size-full"
                                />
                                <div className="bg-gradient-to-t from-black to-transparent flex  flex-col justify-center px-5 py-12 bottom-0 absolute max-md:mt-10 max-md:max-w-full">
                                    <div className="flex gap-2 justify-between py-2 pl-20 text-base tracking-wide leading-7 whitespace-nowrap rounded-lg max-md:flex-wrap max-md:pl-5 max-md:max-w-full">
                                        <img
                                            loading="lazy"
                                            src={example}
                                            className="my-auto w-6 aspect-square"
                                        />
                                        <div className="grow">16 أغسطس 2023</div>
                                    </div>
                                    <div className="mx-4 mb-2.5 text-3xl font-bold max-md:mr-2.5 max-md:max-w-full">
                                        تحدٍ تحول إلى إلهام: قصة نجاح شاب أصيب بالشلل وأصبح مدونًا
                                        ومحاضرًا حول التحفيز والتغلب على الصعوبات
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="justify-end mt-10 w-full max-md:max-w-full">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-0">
                                <div className="flex flex-col max-md:ml-0 max-md:w-full">
                                    <div className="flex flex-col grow justify-center p-6 w-full text-right bg-white rounded-lg max-md:px-5 max-md:mt-8 max-md:max-w-full">
                                        <img
                                            loading="lazy"
                                            srcSet={example}
                                            className="w-full aspect-[1.92] max-md:max-w-full rounded-lg object-cover"
                                        />
                                        <div className="flex flex-col justify-center px-5 pb-4 mt-5 max-md:pl-5 max-md:max-w-full">
                                            <div className="flex gap-2 justify-between py-2 pl-20 text-base tracking-wide leading-7 whitespace-nowrap bg-white rounded-lg text-zinc-600 max-md:flex-wrap max-md:pl-5 max-md:max-w-full">
                                                <img
                                                    loading="lazy"
                                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/fe9ac352c74fd3a4ca28f67304766bea8071427809fd603b7858a3815f660c71?"
                                                    className="my-auto w-6 aspect-square"
                                                />
                                                <div className="grow">16 أغسطس 2023</div>
                                            </div>
                                            <div className="mx-2 text-xl font-bold text-zinc-900 max-md:mr-2.5 max-md:max-w-full">
                                                مساعدة الأطفال ذوي الاحتياجات الخاصة: كيف قامت منظمة غير ربحية
                                                بتوفير تأهيل ودعم مستدام للأطفال المصابين بالتوحد
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex gap-2 justify-center self-center px-4 py-2 mt-10 text-sm font-medium leading-5 whitespace-nowrap bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-neutral-900">
                            <img
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/3c662ea3d5d1a8c5d80c168da176217c00ea220fd13d0ef8a9d5d0ecbdb0e3de?"
                                className="w-6 aspect-square"
                            />
                            <div className="grow my-auto">تحميل المزيد</div>
                        </div>
                    </div >
                )
            }
        </>
    )
}

export default SuccessStory